import { API_URL } from '../../../app-config/constants';
import { UserImportConfiguration, UserImportSystem } from '../../../types/UserImport';
import { get, put } from '../request';

const BASE = `${API_URL}/user-import-configurations`;
export type UserImportConfigurationApi = {
    saveConfig: (payload: UserImportConfiguration) => Promise<UserImportConfiguration>;
    getConfig: (companyId?: string) => Promise<UserImportConfiguration>;
    resetConfig: (companyId: string) => Promise<UserImportConfiguration>;
};

export function createApi(system: UserImportSystem): UserImportConfigurationApi {
    const api = {
        saveConfig: (payload: UserImportConfiguration) => {
            return put<UserImportConfiguration>(`${BASE}/${system}`, {
                postData: payload,
            });
        },

        getConfig: (companyId?: string) => {
            const query = companyId ? `?company=${companyId}` : '';
            return get<UserImportConfiguration>(`${BASE}/${system}${query}`);
        },

        resetConfig: (companyId: string) => {
            return put<UserImportConfiguration>(`${BASE}/${companyId}/${system}`);
        },
    };

    (api.saveConfig as any).operation = 'UPDATE';
    (api.getConfig as any).operation = 'READ';
    (api.resetConfig as any).operation = 'COMMAND';
    (api.resetConfig as any).invalidates = ['getConfig'];

    return api;
}
